import { VStack } from '@cbhq/cds-web/layout';
import React, { memo, ReactNode } from 'react';

type SummaryCardProps = {
  header: ReactNode;
  children: ReactNode;
};

const SummaryCard = memo(function SummaryCard({ header, children }: SummaryCardProps) {
  return (
    <VStack paddingY={3} gap={2} background="bg" borderRadius={300}>
      <VStack paddingX={3}>{header}</VStack>
      <VStack>{children}</VStack>
    </VStack>
  );
});

export default SummaryCard;
